// TestimonialCard.js

const TestimonialCard = (props) => {
    const { review, isHomePage, handleLoading } = props;

    return (
        <div className="testimonial-card">
            <div className="testimonial-card__text">
                <p className="testimonial-card__review">
                    {isHomePage ? `${review.testimonial.fields.reviewSummary}...See More` : review.testimonial.fields.review}
                </p>

                {!isHomePage
                ? <div className="testimonial-card__via">
                    <a href="https://g.page/ajitfurniturehouse" target="_blank" rel="noreferrer">via google</a>
                </div>
                : null
                }

                <div className="testimonial-card__reviewer">{review.testimonial.fields.reviewerName}</div>
                
                <div className="testimonial-card__city">{review.testimonial.fields.city}</div>
            </div>

            {review.image[0] ?
            <div className="testimonial-card__image">
                <div className="loading">
                    <div className="loading-bar"></div>
                </div>
                <img width={100} height={100} src={review.image[0].fields.file.url} alt={review.image[0].fields.title} onLoad={handleLoading} />
            </div>
            : null
            }
        </div>
    )
}

export default TestimonialCard;